module.exports = __webpack_public_path__ + "static/media/FiveStages_Low_Impact_Dance_Fitness.cdf5ef89.webp";